import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { CoreModule } from '@core/core.module';
import { HelpersModule } from '@core/components/helpers/helpers.module';
import { LabelsModule } from '@core/components/labels/labels.module';
import { CoreCustomFormsHelpersSearchFiltersModule } from './filters/filters.module';
import { DynamicViewFieldHostComponent } from './dynamic-field-host-directives/dynamic-view-field-host.component';
import { DynamicFillFieldHostComponent } from './dynamic-field-host-directives/dynamic-fill-field-host.component';

// fields creator components

// const allFieldsComponents = Object.values(Fields);
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        // CoreModule,
        HelpersModule,
        LabelsModule,
        CoreCustomFormsHelpersSearchFiltersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        DynamicFillFieldHostComponent,
        DynamicViewFieldHostComponent
    ],
    exports: [
        DynamicFillFieldHostComponent,
        DynamicViewFieldHostComponent,
        CoreCustomFormsHelpersSearchFiltersModule
    ],

})
export class CoreCustomFormsFieldHelpersModule { }
